<template>
    <div class="QHfileList">
        <div class="li" v-for="(item, index) in values" v-bind:key="index">
            <p>{{ item.name }}</p>
            <span class="tool flex-center">
                <font @click="$QHopen.url($httpFile(item.url),1500)" v-if="isLook">查看</font>
                <font @click="remove(index)" v-if="isRemove">删除</font>
            </span>
        </div>
    </div>
</template>

<script>

export default {
    // +----------------------------------------------------------------------
    // | Desc:data
    // +----------------------------------------------------------------------
    data() {
        return {
            values: [],
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:props
    // +----------------------------------------------------------------------
    props: {
        value: {
            type: [Array, String],
            default: ""
        },
        isLook: {
            type: Boolean,
            default: true
        },
        isRemove: {
            type: Boolean,
            default: true
        }
    },

    // +----------------------------------------------------------------------
    // | Desc:watch
    // +----------------------------------------------------------------------
    watch: {
        value() {
            this.setValue();
        }
    },
    // +----------------------------------------------------------------------
    // | Desc:methods
    // +----------------------------------------------------------------------
    methods: {
        remove(index) {
            this.values.shift(index, 1);
            this.$emit('input', this.values);
            this.$emit('remove', this.values);
        },
        setValue() {
            this.values = this.value;
        }
    }
}
</script>
<style>
.QHfileList .li {
    padding: 10px;
    background: #f5f5f5;
    border-radius: 4px;
    margin: 5px 0 !important;
    color: #444;
    font-size: 14px;
}

.QHfileList .li {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.QHfileList .li .filebox {
    display: none;
}

.QHfileList .li p {
    display: block;
}

.QHfileList .li .tool {
    display: block !important;
    white-space: nowrap;
    word-break: keep-all;
}

.QHfileList .li .tool font {
    color: #3975C6;
    cursor: pointer;
    font-size: 12px;
    white-space: nowrap;
    word-break: keep-all;
    margin-left: 5px;
}

.QHfileList .li .tool font:hover {
    text-decoration: underline;
}
</style>